// Schema.org JSON-LD builders and injection helpers.
// Kept separate from runtime meta-tag mutation (see seo.ts).

import { SITE_URL, FAVICON_URL } from './seo';
import type { Article } from '@/mocks/articles';

type Lang = 'pt' | 'de' | 'en';

const ORG_NAME = 'CSSBuy Spreadsheet Resource';

export function buildHomeSchema(): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: 'CSSBuy Spreadsheet',
    url: `${SITE_URL}/`,
    description:
      'An independent resource with organized product categories, buying guides, QC tips, shipping info, and safety advice for China shopping research.',
    inLanguage: ['pt', 'de', 'en'],
    publisher: {
      '@type': 'Organization',
      name: ORG_NAME,
      url: `${SITE_URL}/`,
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
  };
}

export function buildArticleSchema(article: Article, lang: Lang): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: article.title[lang],
    description: article.description[lang],
    image: article.image,
    author: {
      '@type': 'Organization',
      name: ORG_NAME,
    },
    publisher: {
      '@type': 'Organization',
      name: ORG_NAME,
      logo: {
        '@type': 'ImageObject',
        url: FAVICON_URL,
      },
    },
    datePublished: '2026-08-01',
    dateModified: '2026-08-30',
    mainEntityOfPage: {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/article/${article.slug}`,
    },
  };
}

export function injectJsonLd(id: string, data: object) {
  let el = document.getElementById(id) as HTMLScriptElement | null;
  if (!el) {
    el = document.createElement('script');
    el.type = 'application/ld+json';
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function removeJsonLd(id: string) {
  const el = document.getElementById(id);
  if (el) {
    el.remove();
  }
}